import React, { useState, useEffect } from "react"; 
import { Container, Row, Col } from 'react-bootstrap'
import "./AreaGuide.scss";
import AreaBox from "../BoxBlock/AreaBox" 
import ContentModule from "../../modules/content_module";

import {AreaGuideList, AreaList} from "../../common/queries/common_use_query"

const AreaGuide = ({Module}) => {
    const[areaguide_list, setAreaguideList] = useState([]); 

    const{loading, error, data} = AreaGuideList(); 

    useEffect(() => {
        data?.areaGuides?.length > 0 && setAreaguideList(data?.areaGuides);
    }, [data])
 

    var branche_text = areaguide_list?.length > 1 ? "branches" : "branch"

    return (
        <React.Fragment>
            <section className="location-block area-guide">
                <Container>
                    <Row>
                        <Col>
                            {areaguide_list?.length > 0 && 
                            <div className="box-wrap">
                                {areaguide_list.map((item, index) => (
                                    <AreaBox key={index} BoxList={item} />
                                ))}
                            </div>
                            }
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};
export default AreaGuide;
